import type {SurveySectionSliceDefaultPrimary} from 'prismicio-types'

export type AnswerType = {
  value: number
  text: string
}

export type QuizDataType = {
  question: string
  answers: AnswerType[]
}[]

export const transformData = (data: SurveySectionSliceDefaultPrimary): QuizDataType => {
  const result = []

  for (const key in data) {
    if (key.startsWith('question_')) {
      const questionKey = key
      const answersKey = `answers_${questionKey}`

      if (data[answersKey as keyof SurveySectionSliceDefaultPrimary]) {
        result.push({
          question: String(data[questionKey as keyof SurveySectionSliceDefaultPrimary]),
          answers: (data[answersKey as keyof SurveySectionSliceDefaultPrimary] as unknown as AnswerType[]) || [],
        })
      }
    }
  }

  return result
}
